<nb-card
  style="
    max-height: 70vh;
    min-width: 200px;
    overflow-y: auto !important;
    margin: 10px;
    margin-top: 0;
    border: none;
  "
  size="large"
  *ngIf="isAllowDesign"
>
  <nb-card-header
    style="
      padding: 5px 5px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: space-between;
    "
  >
    <span>List Language</span>
    <button
      class="alert-circle-outline"
      type="button"
      ghost
      nbTooltip="You can change the prompt for each language easily."
      nbTooltipPlacement="bottom"
      nbTooltipStatus="basic"
      nbTooltipTrigger="hover"
      size="small"
      nbButton
    >
      <nb-icon icon="question-mark-circle-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body class="mb-2 mt-2" style="padding: 0 !important">
    <input
      type="text"
      nbInput
      [(ngModel)]="searchText"
      fullWidth
      (keyup)="filterVariable()"
      placeholder="Search Language"
      fieldSize="small"
      class="mb-2"
    />
    <nb-list>
      <nb-list-item
        (click)="clickedRow('all')"
        [class.active]="selectedItem == 'all'"
        class="list-group-item-action justify-content-between align-items-center"
      >
        All Languages
      </nb-list-item>
      <nb-list-item
        (click)="clickedRow(item.language)"
        [class.active]="item.language.split('-')[0] == selectedItem"
        class="list-group-item-action justify-content-between align-items-center"
        *ngFor="let item of languages"
      >
        {{ item.name }}
        <label
          *ngIf="item.defaultUser == true"
          class="bg-light px-2 text-secondary"
          style="font-size: 9px; border-radius: 4px"
        >
          default
        </label>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
  <nb-card-footer style="padding: 0">
    <nb-list (click)="showSetting()">
      <nb-list-item
        class="list-group-item-action justify-content-between align-items-center"
      >
        <div class="d-flex align-items-center" style="gap: 0.5rem">
          <nb-icon icon="settings-outline" status="basic"></nb-icon>
          <span>Manages in Settings</span>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-footer>
</nb-card>
